import React, { useState } from 'react';
import { motion } from "framer-motion";
import InfoUser from "../../components/Profile/InfoUser.js";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

function Profile() {
  const location = useLocation();
  const { userName, data, webSetting } = location.state || {};
  const navigate = useNavigate();
  const [isInfoVisible, setIsInfoVisible] = useState(true);
  const [isChangeInfoVisible, setIsChangeInfoVisible] = useState(true);

  const changeInfo = async (typeModal) => {
    // Bỏ qua kiểm tra, điều hướng trực tiếp
    navigate("/change-info", { state: { userName, data, webSetting, typeModal } });
  };

  return (
    <motion.div
      initial={{ x: "100vw", opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: "-100vw", opacity: 0 }}
      transition={{ type: "spring", stiffness: 1000, damping: 20, duration: 10 }}
      className="overflow-x-hidden p-5"
    >
      <div >
        {/* Header với logo */}
        <div className="w-full h-fit flex justify-center items-center ">
          <img
            src="/search/title-sup-cskh.png"
            alt="logo"
            className="w-full max-w-[300px] h-auto object-contain"
          />
        </div>

        {/* Tiêu đề với nút ẩn/hiện */}
        <button
          onClick={() => setIsInfoVisible(!isInfoVisible)}
          className="w-full flex items-center gap-2 text-[#1F1F1F] text-[16px] md:text-[20px] font-bold leading-[28px] uppercase tracking-wide hover:opacity-80 transition-opacity cursor-pointer mt-6 md:mt-8"
        >
          <span>THÔNG TIN CÁ NHÂN</span>
          <svg
            className={`w-4 h-4 md:w-5 md:h-5 transition-transform duration-300 ${isInfoVisible ? 'rotate-180' : ''}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        {/* Container thông tin người dùng */}
        {isInfoVisible && (
          <div >
            <InfoUser />
          </div>
        )}

      </div>

      {/* Tiêu đề THAY ĐỔI THÔNG TIN MỚI với nút ẩn/hiện */}
      <button
        className="w-full flex items-center gap-2 text-[#1F1F1F] text-[16px] md:text-[20px] font-bold leading-[28px] uppercase tracking-wide hover:opacity-80 transition-opacity cursor-pointer"
      >
        <span>THAY ĐỔI THÔNG TIN MỚI</span>

      </button>

      {/* Container các nút thay đổi thông tin */}
      {isChangeInfoVisible && (
        <div className="w-full grid grid-cols-2 justify-center items-center py-2 gap-2 ">

          <button
            className="cursor-pointer flex items-center justify-center w-full overflow-hidden drop-shadow-[0_2px_4px_rgba(242,113,33,0.4)] hover:drop-shadow-[0_4px_8px_rgba(242,113,33,0.6)] transition-all duration-300 hover:scale-105 hover:opacity-90"
            onClick={() => changeInfo("full_name")}
          >
            <img src='/button/icon-user.png' alt='icon-user' className='max w-[186px] h-auto  object-contain pointer-events-none' style={{ imageRendering: 'crisp-edges' }} />
          </button>
          <button
            className="cursor-pointer flex items-center justify-center w-full overflow-hidden drop-shadow-[0_2px_4px_rgba(242,113,33,0.4)] hover:drop-shadow-[0_4px_8px_rgba(242,113,33,0.6)] transition-all duration-300 hover:scale-105 hover:opacity-90"
            onClick={() => changeInfo("phone_number")}
          >
            <img src='/button/icon-phone.png' alt='icon-phone' className='max w-[186px] h-auto object-contain pointer-events-none' style={{ imageRendering: 'crisp-edges' }} />
          </button>
         

          <button
            className="cursor-pointer flex flex-col items-center justify-center w-full overflow-hidden drop-shadow-[0_2px_4px_rgba(242,113,33,0.4)] hover:drop-shadow-[0_4px_8px_rgba(242,113,33,0.6)] transition-all duration-300 hover:scale-105 hover:opacity-90 gap-2"
            onClick={() => changeInfo("email")}
          >
            <img src='/button/icon-mail.png' alt='icon-mail' className='max w-[186px] h-auto object-contain pointer-events-none' style={{ imageRendering: 'crisp-edges' }} />
          </button>
          <button
            className="cursor-pointer flex items-center justify-center w-full overflow-hidden drop-shadow-[0_2px_4px_rgba(242,113,33,0.4)] hover:drop-shadow-[0_4px_8px_rgba(242,113,33,0.6)] transition-all duration-300 hover:scale-105 hover:opacity-90"
            onClick={() => changeInfo("bank")}
          >
            <img src='/button/icon-bank.png' alt='icon-bank' className='max w-[186px] h-auto object-contain pointer-events-none' style={{ imageRendering: 'crisp-edges' }} />
          </button>
        </div>
      )}

      {/* Nút CHĂM SÓC KHÁCH HÀNG XÁC MINH */}
      {isChangeInfoVisible }
      {/* && (
        <button
          className="w-full mt-4 px-4 md:px-6 py-3 md:py-4 rounded-full bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold text-sm md:text-lg flex items-center justify-center gap-2 md:gap-3 hover:from-blue-600 hover:to-blue-700 transition-all duration-300 shadow-lg hover:shadow-xl"
          onClick={() => changeInfo("verify")}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 md:w-6 md:h-6" viewBox="0 0 24 24" fill="none">
            <path d="M13.4787 2.62368C12.6853 1.75255 11.3147 1.75255 10.5213 2.62368L9.50111 3.74391C9.10016 4.18418 8.52388 4.42288 7.92905 4.39508L6.41553 4.32435C5.23857 4.26934 4.26934 5.23857 4.32435 6.41554L4.39508 7.92905C4.42288 8.52388 4.18418 9.10016 3.74391 9.50111L2.62368 10.5213C1.75255 11.3147 1.75255 12.6853 2.62368 13.4787L3.74391 14.4989C4.18418 14.8998 4.42288 15.4761 4.39508 16.071L4.32435 17.5845C4.26934 18.7614 5.23857 19.7307 6.41553 19.6757L7.92905 19.6049C8.52388 19.5771 9.10016 19.8158 9.50111 20.2561L10.5213 21.3763C11.3147 22.2475 12.6853 22.2475 13.4787 21.3763L14.4989 20.2561C14.8998 19.8158 15.4761 19.5771 16.071 19.6049L17.5845 19.6757C18.7614 19.7307 19.7307 18.7614 19.6757 17.5845L19.6049 16.071C19.5771 15.4761 19.8158 14.8998 20.2561 14.4989L21.3763 13.4787C22.2475 12.6853 22.2475 11.3147 21.3763 10.5213L20.2561 9.50111C19.8158 9.10016 19.5771 8.52388 19.6049 7.92905L19.6757 6.41553C19.7307 5.23857 18.7614 4.26934 17.5845 4.32435L16.071 4.39508C15.4761 4.42288 14.8998 4.18418 14.4989 3.74391L13.4787 2.62368Z" stroke="white" stroke-width="1.5" />
            <path d="M15 12L13 14L9 10" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span>CHĂM SÓC KHÁCH HÀNG XÁC MINH</span>
        </button>
      ) */}



    </motion.div>
  );
}

export default Profile;
